var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-upload",
            {
              ref: "uploadFileXls",
              attrs: {
                limit: 1,
                action: "",
                drag: "",
                accept: ".pdf, .doc, .docx, .xls, .xlsx",
                "http-request": _vm.uploadFile,
                "auto-upload": false,
                "file-list": _vm.fileList,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }